import { render, staticRenderFns } from "./TabelaAjusteRateiosEmMassa.vue?vue&type=template&id=16387856"
import script from "./TabelaAjusteRateiosEmMassa.vue?vue&type=script&lang=js"
export * from "./TabelaAjusteRateiosEmMassa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports